<div class="card mb-0">
    <div class="flex justify-between mb-4">
        <div>
            <span class="block text-muted-color font-medium mb-4">Projects</span>
            <div class="text-surface-900 dark:text-surface-0 font-medium text-xl">{{projectCount}}</div>
        </div>
        <div class="flex items-center justify-center bg-orange-100 rounded-border" [ngStyle]="{width: '2.5rem', height: '2.5rem'}">
            <i class="pi pi-inbox text-orange-500 text-xl!"></i>
        </div>
    </div>
    <span class="text-green-500 font-medium">Coming Soon</span>
    <span class="text-500"></span>
</div>
